import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AccessGroups.translations.json';
import { NotFound } from '../NotFound';
import { AccessGroupDirectory } from './AccessGroupDirectory';
import { AccessGroupBreadcrumbsData } from './AccessGroupBreadcrumbs';
import { AccessGroupDetails } from './AccessGroupDetails';
import { AccessGroupEdit } from './AccessGroupEdit';
import { AccessGroupCreate } from './AccessGroupCreate';

export const { addTranslations, useTranslation, Translation } =
  i18nNsFactory('access-groups-page');
addTranslations(translations);

export const ACCESS_GROUP_ROUTES = [
  {
    path: path.accessGroupDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.access-groups')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <AccessGroupDirectory />,
      },
      {
        path: path.accessGroupCreate,
        element: <AccessGroupCreate />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.access-group-create')}
          </Translation>
        ),
      },
      {
        path: path.accessGroupDetails,
        element: <AccessGroupDetails />,
        renderBreadcrumb: (data?: AccessGroupBreadcrumbsData) =>
          data ? (
            data.name
          ) : (
            <Translation>
              {(t) => t('breadcrumb.access-group-detail')}
            </Translation>
          ),
      },
      {
        path: path.accessGroupEdit,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.access-group-edit')}</Translation>
        ),
        element: <AccessGroupEdit />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const AccessGroups: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, ACCESS_GROUP_ROUTES));
